export default __webpack_public_path__ + "static/media/muliLive.3075553e.png";